import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationSubscriptionsDelete = {
    path: "/subscription",
    method: ERouteHttpVerb.DELETE
};
export { routeLocationSubscriptionsDelete };
